import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
import Icons from '_c/icons';
export default {
  name: 'CommonIcon',
  components: {
    Icons: Icons
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    color: String,
    size: Number
  },
  computed: {
    iconType: function iconType() {
      return this.type.indexOf('_') === 0 ? 'Icons' : 'Icon';
    },
    iconName: function iconName() {
      return this.iconType === 'Icons' ? this.getCustomIconName(this.type) : this.type;
    },
    iconSize: function iconSize() {
      return this.size || (this.iconType === 'Icons' ? 18 : 18);
    },
    iconColor: function iconColor() {
      return this.color || '';
    }
  },
  methods: {
    getCustomIconName: function getCustomIconName(iconName) {
      return iconName.slice(1);
    }
  }
};